import React, { useState, useEffect } from "react";
import apiClient from "../../AppClient";
import { Container, Table, Alert, Spinner, Card } from "react-bootstrap";

const SuppliersAnalysisReport = () => {
  const [suppliersData, setSuppliersData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch suppliers data
  const fetchSuppliersData = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/transactions/reports/get-suppliers-analysis");
      setSuppliersData(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "فشل في جلب تقرير الموردين.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSuppliersData();
  }, []);

  return (
    <Container style={{ 
      direction: "rtl", 
      textAlign: "right", 
      padding: "20px", 
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: "black", 
      backgroundColor: "white" 
    }}>
      <h1 style={{ color: "darkgreen", marginBottom: "20px" }}>تحليل الموردين</h1>

      {/* Error Message */}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: "darkgreen" }}>
            <span className="visually-hidden">جاري التحميل...</span>
          </Spinner>
        </div>
      ) : (
        /* Suppliers Analysis Table */
        <Card style={{ padding: "20px", border: "1px solid darkgreen", borderRadius: "5px" }}>
          <h4 style={{ color: "darkgreen" }}>تحليل الموردين</h4>
          <Table hover responsive>
            <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
              <tr>
                <th>اسم المورد</th>
                <th>إجمالي المشتريات</th>
                <th>إجمالي المدفوعات</th>
                <th>الرصيد المتبقي</th>
                <th>تاريخ آخر عملية شراء</th>
              </tr>
            </thead>
            <tbody>
              {suppliersData?.map((supplier, index) => (
                <tr key={index}>
                  <td>{supplier.supplier_name}</td>
                  <td>{supplier.total_purchases.toFixed(2)}</td>
                  <td>{supplier.total_payments.toFixed(2)}</td>
                  <td>{supplier.remaining_balance.toFixed(2)}</td>
                  <td>{supplier.last_purchase_date || "لا يوجد"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}
    </Container>
  );
};

export default SuppliersAnalysisReport;
